export default function () {
  const megaMenus = document.querySelectorAll('.mega-menu-container-list')
  megaMenus.forEach((ul) => {
    const item =  ul.querySelectorAll("a")
    if(item.length < 23) {
      ul.style.height = '190px'
    }
  })
};